<script>
import Credits from '@/components/cutscenes/Credits'
import StyledButton from '@/components/snippets/StyledButton'

import music from '@/services/music'

export default {
  name: 'ViewCredits',

  components: {
    Credits,
    StyledButton
  },

  mounted () {
    music.play('ambient1')
  }

}
</script>

<template>
  <div class="c-view-credits">
    <div class="c-view-credits-content">

      <styled-button to="/">
        Back to title screen
      </styled-button>

      <credits class="c-view-credits-body" />

    </div>
  </div>
</template>

<style lang="scss">

.c-view-credits-content {
  @include keep-center;
  @include limit-content;
}

.c-view-credits-body {
  @include push-top-even;
}

</style>
